export const textareaAutoGrow = (e: any) => {
	e.target.style.height = 'inherit';
	e.target.style.height = `${e.target.scrollHeight}px`;  
};